import { IOpenAiLogFeedback } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/client-api/open_ai_log_feedback';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {};
const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IOpenAiLogFeedback>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
